{
  "targetTypes": {
    "sale": "Sale",
    "lead": "Lead",
    "insight": "Insight"
  },
  "answerTypes": {
    "positive": "Erfolgreich",
    "negative": "Erfolglos",
    "not_addressed": "Keine Ansprache"
  },
  "common": {
    "yes": "Ja",
    "no": "Nein",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "close": "Schließen",
    "logout": "Abmelden"
  },
  "misc": {
    "confirmRouteLeave": {
      "message": "Seite wirklich verlassen? Ungespeicherte Änderungen gehen verloren.",
      "header": "Ungespeicherte Änderungen",
      "acceptLabel": "Verlassen"
    }
  },
  "loginView": {
    "title": "Willkommen zurück!",
    "initialLoginTitle": "Willkommen bei intellivend!",
    "initialLoginError": {
      "linkInvalid": "Der Einladungslink ist unvollständig oder ungültig. Bitte melden Sie sich mit den Zugangsdaten aus der Einladungs-E-Mail an oder fordern Sie eine neue Einladung an.",
      "signInFailed": "Die Anmeldung über den Einladungslink war nicht möglich – möglicherweise ist er abgelaufen. Bitte melden Sie sich mit den Zugangsdaten aus der Einladungs-E-Mail an oder fordern Sie eine neue Einladung an."
    },
    "changePassword": "Eigenes Passwort vergeben",
    "resetPassword": "Passwort zurücksetzen",
    "enterEmail": "E-mail eingeben",
    "enterPassword": "Passwort eingeben",
    "invalidCredentials": "Anmeldung nicht möglich. Zugangsdaten prüfen und erneut versuchen.",
    "passwordMatch": "Die Passwörter müssen übereinstimmen",
    "passwordPolicy": {
      "length": {
        "short": "Mindestens 12 Zeichen",
        "long": "Passwort muss mindestens 12 Zeichen lang sein"
      },
      "lowercase": {
        "short": "Mindestens 1 Kleinbuchstabe",
        "long": "Passwort muss Kleinbuchstaben enthalten"
      },
      "uppercase": {
        "short": "Mindestens 1 Großbuchstabe",
        "long": "Passwort muss Großbuchstaben enthalten"
      },
      "digit": {
        "short": "Mindestens 1 Ziffer",
        "long": "Passwort muss Ziffern enthalten"
      },
      "symbol": {
        "short": "Mindestens 1 Sonderzeichen",
        "long": "Passwort muss Sonderzeichen enthalten"
      },
      "heading": "Passwortrichtlinien"
    },
    "signInWithCustomerOIDC": "Mit O365 anmelden",
    "signInAsKMHSupport": "Als KMH-Support anmelden",
    "redirectingToSidebar": "Wir bereiten alles vor – gleich geht es weiter"
  }
}
